module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0050.jpg?v=d23522ac";